import ThemedLayout from 'components/atoms/ThemedLayout'
import i18n from 'utils/i18n'
import ThemedSafeAreaComponentTop from 'components/atoms/ThemedSafeAreaTop'
import React, { useEffect, useState } from 'react'
import HomeMoreTravelHistoryHistoryScene from 'scenes/home/more/travel_history/_tabs/history'
import LoadingComponent from 'components/atoms/Loading'
import TabbedContent from 'components/molecules/TabbedContent'
import HelperString from 'utils/helper-string'
import HomeMoreTravelHistoryProfilesScene from 'scenes/home/more/travel_history/_tabs/profiles'

const HomeMoreTravelHistoryScene = () => {
	
	const [ loading, setLoading ] = useState( true );
	const [ topTabbar, setTopTabbar ] = useState( null )
	
	useEffect(() => {
		setLoading( false )
	}, [])
	
	const tabBarItems = [];
	tabBarItems.push( {
		key: 'more_travel_history',
		text: i18n.t( 'tabs.more_travel_history_history' ),
		scene: (props) => {
			return <HomeMoreTravelHistoryHistoryScene />;
		}
	});
	
	tabBarItems.push({
		key: 'cache',
		text: i18n.t( 'tabs.more_travel_history_profiles' ),
		scene: ( props ) => {
			return <HomeMoreTravelHistoryProfilesScene />;
		}
	});
	
	let content = <LoadingComponent />
	if( !loading ) {
		content = (
			<TabbedContent
				key={ HelperString.hash('travel-history-tabs' ) }
				topTabbar={ setTopTabbar }
				items={ tabBarItems }
			/>
		)
	}
	
	return (
		<ThemedSafeAreaComponentTop top={false}>
			<ThemedLayout
				topNavigation={ true }
				topTabbar={ topTabbar }
				showBackButton={ true }
				title={ i18n.t( 'titles.more_travel_history') }>
				
				{ content }
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	)
}

export default HomeMoreTravelHistoryScene
